import api from './client'

// Cuentas web (/clientes/cuentas-web): la base que se forma en ligier.com.ar
// y todavía no está (o no quedó atada) en LGR.
export const cuentasWebApi = {
  listar: (params) => api.get('/cuentas-web', { params }),
  vincular: (id, clienteId, confirmarEmailDistinto = false) =>
    api.post(`/cuentas-web/${id}/vincular`, { cliente_id: clienteId, confirmar_email_distinto: confirmarEmailDistinto }),
  razonesSociales: (id) => api.get(`/cuentas-web/${id}/razones-sociales`),
  agregarRazonSocial: (id, clienteId) => api.post(`/cuentas-web/${id}/razones-sociales`, { cliente_id: clienteId }),
  quitarRazonSocial: (id, clienteId) => api.delete(`/cuentas-web/${id}/razones-sociales/${clienteId}`),
  // Cierra todas las sesiones abiertas de la cuenta en la tienda (todos los dispositivos).
  cerrarSesiones: (id) => api.post(`/cuentas-web/${id}/cerrar-sesiones`),
}
